import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import ReactDragList from 'react-drag-list';
import { toast, ToastContainer} from 'react-toastify';
import {Col, Row} from 'reactstrap';
import { Player, BigPlayButton } from "video-react";
import "node_modules/video-react/dist/video-react.css";
import styled from 'styled-components'

import withServices  from '../../../../HOCs/withServices';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import { processDrag, processRedWords } from "../../../../common/utils";
import ScreenViewer from "../../../../common/screenViewerHtml";
import {PROXIED_MEDIABASE} from '../../../../common/constants';

import RecallInteraction from "../../../../components/RecallInteraction/RecallInteraction.Component";
import DragDropInteraction from "../../../../components/DnDInteraction/DragDropInteraction.Component";
import MultipleChoiceInteraction from "../../../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component";
import MultipleChoiceMultiInteraction from "../../../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component";

import { ModalWrapper, Wrapper, Content, ContentCol,ContentRow, ContentRowSingleCol, StyledSectionHeader} from './CoursePreview.styles';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
  }
  
  interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
  }

  const PreviewRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    div {
        margin-right: 16px;
    }
`
const AssetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignment};
    justify-content: center;
    max-width: ${props => props.assetWidth}%;
    width: ${props => props.assetWidth}%;
    padding: 8px;
`
const PreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-color: ${props => props.bgColor};
    color: #fff;
    width: 100%;
    min-height: 600px;
    min-width: 600px;
    height: 100%;
    padding: 16px 16px;
`

  class CoursePreview extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.selectLesson = this.selectLesson.bind(this);
        this.selectScreen = this.selectScreen.bind(this);
        this.setSelected = this.setSelected.bind(this);
    }

    public onGoBack() {
        const { history } = this.props;
    
        const dest = this.props.services.currentBaseUrl + 'courses/' + this.state.data.courseID
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: courseID } } = match;

        const courseLessonRes = await adminAPI.getCurrentCourseLessons({ courseID});

        if (courseLessonRes.ok) {
            
            const courseLessons = courseLessonRes.data.course_lessons;
            this.setState(
                {
                     data: {
                         activetab: '1',
                         courselessons: courseLessons,
                         courseID,
                         currentInteraction: {},
                         selectedLessonID: null,
                         loaded: true,
                         screens: [],
                         screenIndex: 0,
                         screenSelected: true
                     }
                }
                );
        } else {
            toast.error('Error fetching course details!');
          }
    
    }

    public async selectLesson (data, lesson) {
        console.log(lesson);
        data.loaded = false;
        data.selectedLessonID = lesson.Lesson;

        
        data.ScreenSelected = false;
    
        data.screens = [];

        this.setState({data});

        const screensRes = await this.props.services.adminAPI.getLessonScreensInteractionsAnonymous(data.selectedLessonID, 1);

        if (screensRes.ok) {
            
            const screens = screensRes.data.screens;

            data.screens = screens;

            console.log("Screens? " + JSON.stringify(screens, null, 4));

            this.setState({data});
        }        
    }

    public showLessons(data) {

        return(
            data.courselessons.map(
                (d, i) =>
                // tslint:disable-next-line jsx-no-lambda
                <li key={d.id} onClick={() => this.selectLesson(data,d)} style={{  margin: 6 }}><p style={{color: 'white'}}>{d.Title}</p></li>
            )
        );
    }
    public generatePreviewAsset = (asset, idx, rowId, columns) => {
        if (asset === null) {
          return <p style={{ width: '100%' }} />
        } else {
          if (asset.type === 'image') {
            return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
              <img src={asset.content} style={{ width: `${asset.size}px` }} alt="img" />
            </AssetWrapper>
          }
          if (asset.type === 'icon') {
            return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
              <img src={asset.content} style={{ width: `${asset.size}px` }} alt="icon" />
            </AssetWrapper>
          }
          if (asset.type === 'text') {
            return <div style={{ maxWidth: `${Math.round(100 / columns)}%`, width: '100%', padding: '8px' }} key={`${rowId}-${idx}`} dangerouslySetInnerHTML={{ __html: asset.content }} />
          }
    
          if (asset.type === 'video') {
            return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
              <video src={asset.content} style={{ width: `${asset.size}px` }} controls={true} />
            </AssetWrapper>
          }
        }
        return;
      }

      public getAlignment = (align) => {
        if (align === 'left') { return 'flex-start' }
        if (align === 'center') { return 'center' }
        if (align === 'right') { return 'flex-end' }
        return;
      }

    public showContent(screen) {
        const { LessonScreenId } = screen;
        const { rows, rowOrder } = screen.DisplayData;
        return (
            <div style={{backgroundColor: 'white'}}>
                {/* <ScreenViewer
                    screenid={screen.id}
                    screenpdf={screen.DisplayData.html}
                    screenbg={screen.DisplayData.background}
                    pageNumber={1}
                    style={{padding: '8px'}}
                /> */}
                <PreviewContainer bgColor={screen.DisplayData.background}>
                  <React.Fragment>
                    {rowOrder.map((rowId, idx) => {
                      const row = rows[rowId];
                      const assets = row.assets;

                      return <PreviewRow
                        key={`${LessonScreenId}-${row.id}`}
                      >
                        {assets.map((asset, idx) => {
                          { return this.generatePreviewAsset(asset, idx, rowId, assets.length) }
                        })}
                      </PreviewRow>
                    })}
                  </React.Fragment>
                </PreviewContainer>
            </div>
        );
    }

    public interactionComplete(score) {
        toast.info("interaction completed: " + score);
    }

    public showVideo(screen) {
        return (
                <div className="lesson-video-container">
                  <Player
                    playsInline={true}
                    poster={PROXIED_MEDIABASE + "assets/" + "download.jpg"}
                    src={PROXIED_MEDIABASE + "assets/" + screen.VideoUrl}
                    height={640}
                    width={960}
                  >
                    <BigPlayButton position="center" />
                  </Player>
                </div>
        );
    }

    public showImage(screen) {
        return (
                <div className="lesson-image-container">
                  <img
                    className="lesson-screen-image"
                    src={PROXIED_MEDIABASE + "assets/" + screen.VideoUrl}
                  />
                </div>
        );
    }


    public showInteraction (screen) {
        if (screen.interaction === {}) {
            return <p>No Interaction Data</p>;
        }
        else{
            
                if (screen.interaction.interaction_type === "choice") {
                  if (screen.interaction.choice_type === "single_choice") {
                    return (
                      <MultipleChoiceInteraction
                        oncomplete={this.interactionComplete}
                        demomode={true}
                        show={true}
                        lessonid={screen.Lesson}
                        interactionid={screen.interaction.id}
                        completiontext={screen.interaction.completion_text}
                        submittext={"Submit"}
                        introtext={screen.interaction.intro_text}
                        question={screen.interaction.question_text}
                        answers={screen.interaction.choice_answers}
                        penalty={screen.interaction.penalty}
                        timelimit={screen.interaction.time_limit}
                      />
                    );
                  }
                  else {
                    return (
                      <MultipleChoiceMultiInteraction
                        oncomplete={this.interactionComplete}
                        demomode={true}
                        show={false}
                        lessonid={screen.Lesson}
                        interactionid={screen.interaction.id}
                        completiontext={screen.interaction.completion_text}
                        submittext={"Submit"}
                        introtext={screen.interaction.intro_text}
                        question={screen.interaction.question_text}
                        answers={screen.interaction.choice_answers}
                        penalty={screen.interaction.penalty}
                        timelimit={screen.interaction.time_limit}
                      />
                    );
                  }
        }

        else if (
            screen.interaction.interaction_type === "draganddrop" ) 
        {
            return (
              <DragDropInteraction
                oncomplete={this.interactionComplete}
                demomode={true}
                show={true}
                lessonid={screen.Lesson}
                interactionid={screen.interaction.id}
                completiontext={screen.interaction.completion_text}
                submittext={"Submit"}
                introtext={screen.interaction.intro_text}
                dragquestions={
                    screen.interaction.options}
                penalty={screen.interaction.penalty}
                timelimit={screen.interaction.time_limit}
              />
            );
        }
        else if (
            screen.interaction.interaction_type === "recall"
          ) 
        {
            return (
              <RecallInteraction
                oncomplete={this.interactionComplete}
                demomode={true}
                show={true}
                lessonid={screen.Lesson}
                interactionid={screen.interaction.id}
                completiontext={screen.interaction.completion_text}
                submittext={"Submit"}
                introtext={screen.interaction.intro_text}
                question={screen.interaction.paragraph_copy}
                redwords={processRedWords(
                    screen.interaction.recall_words
                )}
                penalty={screen.interaction.penalty}
                timelimit={screen.interaction.time_limit}
              />
            );
        }

        else{
            return (<p>Unkown interaction Type</p>)
        }
    }

}

    public showLessonInfo(data) {
        if (!data.selectedLessonID) {
            return (
                <p style={{color: '#ff3300'}}>Please Select a lesson</p>
            );
        }
        else{
            if (data.screens.length > 0) {
                return (
                    <React.Fragment>
                        {data.ScreenSelected?this.showScreen(data.screens[data.screenIndex]):<p style={{color: 'white'}}>Click on a page number</p>}

                        <br/><br/>
                        
                        {this.paginate(data)}
                    </React.Fragment>
                    
                )
            }
            else{
                return(<p style={{color: '#ff3300'}}>No screens for this lesson</p>);
            }
        }
    }

    public async selectScreen (data, idx) {
        data.ScreenSelected = false;
        data.screenIndex = idx;
        this.setState(data);
        
        if (data.screens[data.screenIndex].ScreenType=== 1) {
            console.log('fetch inter')
            console.log(data.screens[data.screenIndex]);
            const res = await this.props.services.adminAPI.getInteractionFromUrl(data.screens[data.screenIndex].interaction_url.replace("/api/v1/", ""));
            
            if (res.ok) {
            
                const currentInteraction = res.data;
                console.log("SelectedScreen: " + JSON.stringify(currentInteraction, null, 4));
                data.screens[data.screenIndex].interaction = currentInteraction;

                console.log(currentInteraction);

                this.setState(data);
            }
        
        }

        setTimeout(this.setSelected, 100);
    }

    public setSelected () {
        const data = this.state.data;
        data.ScreenSelected = true;
        this.setState(data); 
    }

    public paginate (data) {
        if (data.screens.length > 0) {

            const pages = data.screens.map(
                (d, i) =>
                // tslint:disable-next-line jsx-no-lambda
                <a key={i} onClick={() => this.selectScreen(data, i)} style={{  margin: 13, color: 'white' }}>{i + 1}</a>
            )

            return (
                <div>
                    {pages}
                </div>
                
            )
        }

        else {
            return "";
        }

    }


    public showScreen (screen) {
        console.log(`InteractionScreen: ` + JSON.stringify(screen, null, 4));
 
        if (!screen) {
            return (<p>No Screen Selected</p>);
        }

        if (screen.ScreenType=== 0) {
            return this.showContent(screen);
        }
        else if (screen.ScreenType=== 1) {
            return this.showInteraction(screen);
        }
        else if (screen.ScreenType=== 2) {
            return this.showVideo(screen);
        }
        else if (screen.ScreenType=== 3) {
            return this.showImage(screen);
        }

        else{
            return(
                <p>Unkown screen type</p>
            )
        }
        
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                 </ContentRow>

                 <Row>

                    <Col lg="3">

                        <ul>{this.showLessons(data)}</ul>
                    </Col>

                    <Col lg="9">

                        <div className="lesson-preview--content-wrapper">
                            <div className="lesson-preview--content">
                                {this.showLessonInfo(data)}
                            </div>
                
                        </div>
                    </Col>

                 </Row>

                </Content>
                </Wrapper>

        )

    }

}

export default withServices(CoursePreview);


// WEBPACK FOOTER //
// ./src/pages/Admin/Courses/CoursePreview/CoursePreview.tsx